import React, { useEffect, useState } from 'react';
import { Help, Info } from '@adac-mp/components/src/Icons';
import { Drawer, DrawerContent, IconButton } from '@adac-mp/components';
import { useViewport } from '@adac-mp/components/src/hooks/useViewport';
import { ClickEvent } from '../../utils/tracking/types';
import { ContentfulDrawerContent } from '../ContentfulDrawerContent';

enum EPopupPaddingXSize {
	small = 'px-1.5',
	large = 'px-5',
}

type PaddingXSize = keyof typeof EPopupPaddingXSize;

interface IPopupProps {
	title: string;
	iconTitle?: string;
	type: 'help' | 'info';
	bold?: boolean;
	paddingX?: PaddingXSize;
	paddingY?: PaddingXSize;
	content?: {
		title?: string;
		content: React.ReactNode;
	};
	contentfulId?: string;
	buttonStyle?: string;
	iconSize?: string;
	tracking?: ClickEvent;
	trackingElement?: string;
}

export const IconPopup = ({
	type,
	title,
	bold = false,
	paddingX = 'small',
	content,
	contentfulId,
	iconTitle,
	buttonStyle = '',
	tracking,
	paddingY,
	iconSize,
	trackingElement,
}: IPopupProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const { viewport } = useViewport();

	useEffect(() => {
		if (isOpen) {
			document.body.classList.add('overflow-hidden');
		}
		return () => document.body.classList.remove('overflow-hidden');
	}, [isOpen]);

	return (
		<>
			{type === 'info' && (
				<IconButton
					title={title}
					ariaLabel={`Info Button ${title}`}
					className={`opacity-80 border-none transition-opacity hover:opacity-100 rounded-half focus-visible:outline outline-2 ${buttonStyle}`}
					tracking={{
						icon_click: tracking || {
							label: `Infos zur ${title}`,
							element: trackingElement || title,
							category: 'Content',
						},
					}}
					onClick={(e) => {
						e.stopPropagation();
						setIsOpen(true);
					}}>
					<Info strokeWidth={bold ? '2' : '1'} title={iconTitle} size={iconSize} />
				</IconButton>
			)}
			{type === 'help' &&
				(viewport === 'mobile' ? (
					<IconButton
						title={title}
						className="cursor-pointer opacity-80 border-none transition-opacity hover:opacity-100"
						onClick={() => setIsOpen(true)}>
						<Help />
					</IconButton>
				) : (
					<IconButton
						title={title}
						className="cursor-pointer flex border-none items-center gap-2 px-4 py-2.5 rounded bg-black opacity-30 transition-opacity hover:opacity-60 text-white"
						onClick={() => setIsOpen(true)}>
						<Help fill="white" size={iconSize} />
						<span className="text-lg font-bold">Hilfe</span>
					</IconButton>
				))}
			{isOpen && (
				<Drawer isOpen={isOpen} paddingX={paddingX} paddingY={paddingY} title={title} setIsOpen={setIsOpen}>
					{contentfulId ? (
						<ContentfulDrawerContent id={contentfulId} />
					) : (
						<DrawerContent title={content?.title} content={content?.content} />
					)}
				</Drawer>
			)}
		</>
	);
};
